import React from 'react';
import clsx from 'clsx';
import * as Styled from './AEyebrow.styles';
import { AEyebrowVariant } from './AEyebrow.types';
import type { AEyebrowProps } from './AEyebrow.types';

const COMPONENT_NAME = 'a-web-ui-kit-AEyebrow';
const TEST_ID = 'web-ui-kit-AEyebrow';

export const AEyebrow: React.FC<AEyebrowProps> = ({
  eyebrowText,
  variant = AEyebrowVariant.Primary,
  className,
  children,
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={clsx(className, variant === AEyebrowVariant.Primary ? 't-overline-alt-normal' : 't-overline-overlay')}
      {...rest}
    >
      {eyebrowText ?? children}
    </Styled.Wrapper>
  );
};

export { AEyebrowVariant, TEST_ID as A_EYEBROW_TEST_ID };
